var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tint-image-control"
  }, [_c('div', {
    ref: "colorContainer",
    staticClass: "ugc-tint-image-control-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.colorValue,
      expression: "colorValue"
    }],
    ref: "color_input",
    staticClass: "jscolor ugc-tint-image-control-input",
    attrs: {
      "value": "#fff"
    },
    domProps: {
      "value": _vm.colorValue
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.colorValue = $event.target.value;
      }
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }